import { h, Component } from 'preact';
import util from 'preact-util';
import { observer } from 'mobx-preact';
import { Text, Localizer } from 'preact-i18n';
import Markdown from 'preact-markdown';
import { route } from 'preact-router';

import ImageScroller from '../../components/imagescroller';
import ClipboardCopy from '../../components/gui/clipboardCopy';
import GoogleSheet from '../../components/google/sheet';
import Placeholder from '../../components/gui/placeholder';
import MarkdownDisplay from '../../components/gui/markdownDisplay';
import PlaceholderTable from '../../components/gui/placeholderTable';

import VideoStreamingPlayer from '../../routes/videostreaming/player';
import ArticleSponsorOverlay from './sponsorOverlay';

import Comments from '../../components/comments';
import Likes from '../../components/likes';
import TranslationButtons from '../../components/translation/buttons';
import Avatar from '../gui/avatar';
import { openUserProfileDrawer } from '../../lib/userProfile';
import { openArticle } from '../../lib/articleLinks';
import RelatedPosts from './relatedPosts';
import RelatedArticles from './relatedArticles';
import PaywallCta from '../articleRender/paywallCta';

import { MapContainer, TileLayer, Marker, useMap } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';

function MapInteractionToggle({ enabled }) {
    const map = useMap();
    if (enabled) {
        map.dragging.enable();
        map.scrollWheelZoom.enable();
        map.touchZoom.enable();
        map.doubleClickZoom.enable();
        map.boxZoom.enable();
        map.keyboard.enable();
    } else {
        map.dragging.disable();
        map.scrollWheelZoom.disable();
        map.touchZoom.disable();
        map.doubleClickZoom.disable();
        map.boxZoom.disable();
        map.keyboard.disable();
    }
    return null;
}

import localUtil from '../../lib/util';
import Sparkline from '../../components/gui/sparkline';
import { fixImageSrc } from '../articleRender/articleContentProcessor';
import renderArticleBody from '../articleRender/bodyRenderer';
import ResultsList from '../articleRender/resultsList';
import { linkifyMentions } from '../../lib/mentions';
import { decorateExternalLinks } from '../../lib/externalLinks';
import FishCatchCard from '../fishCatch/card';
import FishContactCard from '../fishContact/card';

function partImg(img, props, size = '150x') {
    if (typeof img !== 'object') {
        return undefined;
    }
    const imgSrc = `${img.s3LargeLink}`;
    return imgSrc;
}

@observer
class ArticleView extends Component {
  	constructor(props) {
        super(props);
        this.state = {
            sessionid: new Date().getTime(),
            activeTranslation: null,
            translationLoading: null,
        };
        this.mainContainer = null;
    }

    loadAll = async (props = this.props) => {
        const { id, uuidv4, category, all, userOnly } = props;
        this.setState({ activeTranslation: null, translationLoading: null });
        const { articleStore, appState } = this.props.stores;
        if (id) {
            articleStore.updateKeyValue('article', {});
            articleStore.updateKeyValue('googleSheet', {});

            const query = { hostname: articleStore.currentHostname };
            if (all) {
                query.all = 1;
            }
            if (userOnly) {
                query.userOnly = true;
            }
            await articleStore.load(id, false, { addData: ['tags', 'likes', 'comments', 'polls', 'creators'], query });
            const { article } = articleStore;
            appState.trackArticle('view', article);
            if (article.googleSheetId) {
                articleStore.getGoogleSheet(article.googleSheetId);
            }
        }
        if (uuidv4) {
            articleStore.updateKeyValue('article', {});
            const articles = await articleStore.load({
                addData: ['tags', 'likes', 'comments', 'polls', 'creators'],
                query: {
                    uuidv4,
                    hostname: articleStore.currentHostname,
                },
                skipUpdate: true,
            });
            articleStore.updateKeyValue('article', articles[0]);
            appState.updateMetaTags(articles[0]);
            const { article } = articleStore;
            appState.trackArticle('view', article);
            if (article?.googleSheetId) {
                articleStore.getGoogleSheet(article.googleSheetId);
            }
        }
        if (category) {
            articleStore.updateKeyValue('article', {});
            const articles = await articleStore.load({
                addData: ['tags', 'likes', 'comments', 'polls', 'creators'],
                query: {
                    category,
                    hostname: articleStore.currentHostname,
                },
                skipUpdate: true,
            });
            articleStore.updateKeyValue('article', articles[0]);
            appState.updateMetaTags(articles[0]);
            const { article } = articleStore;
            appState.trackArticle('view', article);
            if (article?.googleSheetId) {
                articleStore.getGoogleSheet(article.googleSheetId);
            }
        }
    }

    viewTags = obj => {
        if (!obj) {
            return '';
        }
        if (obj.tags?.length === 0 && obj.loans?.length === 0 && !obj.ownedByOther && !obj.url && !obj.parents?.length > 0 && !obj.files?.length > 0) {
            return '';
        }
        const { userStore } = this.props.stores;
        const { user = {} } = userStore;
        const darkmode = util.getNestedValue(user, 'settings.darkmode');
        const tagClass = darkmode ? 'dark' : 'light';

        return (<>
            <div class='w-100 overflow-hidden'>
                <div class='box-line-tags d-flex flex-wrap'>
                    {obj.files?.length > 0 && <>
                        <span class={`badge text-bg-light me-1 mt-1`}>
                            <i class='fa-duotone fa-file' /> <span class='font-weight-lighter'> x {obj.files.length}</span>
                        </span>
                    </>}
                    {obj.tags?.length > 0 && obj.tags.map(tag => {
                        return (<>
                            <span
                                class={`badge text-bg-${tagClass} me-1 mt-1`}
                                data-tag={tag.name}
                            >#{tag.name}</span>
                        </>);
                    })}
                </div>
            </div>
        </>);
    }

    // editArticle = () => {
	// 	const { id, drawerLevel } = this.props;
	// 	const { appState } = this.props.stores;
	// 	const { drawerHeightMedium } = appState;
	// 	appState.openDrawer('editArticle', {
	// 		height: drawerHeightMedium,
	// 		id,
	// 	}, drawerLevel + 1);
	// }

    editArticle = e => {
        e.preventDefault();
        e.stopPropagation();
        const { appState, articleStore } = this.props.stores;
        const { article = {}, googleSheet } = articleStore;

        // console.log('editArticle', { id, title });
		const { drawerLevel = 1, category } = this.props;
		const { drawerHeightMediumLarge } = appState;
        // console.log('editArticle', { id, title, userOnly, showCreateButton, category });
		appState.openDrawer('editArticle', {
			height: drawerHeightMediumLarge,
			id: article.id,
            userOnly: category === 'marketplace' || category === 'feed' ? 1 : 0,
            category,
            callback: () => {
                this.loadAll(this.props, false, false);
            },
		}, drawerLevel + 2);
	}

    viewInstallation = e => {
        const { id } = e.currentTarget.dataset;
        const { appState } = this.props.stores;
        appState.toggleDrawer();
        route(`/installation/${id}`);
    }

    closeAllDrawers = () => {
        const { appState } = this.props.stores;
        appState.toggleDrawer();
    }

    applyExternalLinkAttributes = () => {
        decorateExternalLinks(this.mainContainer);
    }

    handleTranslate = async (language) => {
        const { articleStore } = this.props.stores;
        const { article = {} } = articleStore;
        if (!article.id) {
            return;
        }
        this.setState({ translationLoading: language });
        try {
            const response = await util.fetchApi(`/api/articles/${article.id}/translate`, { method: 'POST' }, { language });
            if (response && response.status === 200 && response.data) {
                this.setState({
                    activeTranslation: {
                        language,
                        translation: response.data.translation,
                    },
                    translationLoading: null,
                });
            } else {
                console.error('[Translation] Failed:', response?.message);
                this.setState({ translationLoading: null });
            }
        } catch (error) {
            console.error('[Translation] Error:', error);
            this.setState({ translationLoading: null });
        }
    }

    clearTranslation = () => {
        this.setState({ activeTranslation: null });
    }

    openRelatedArticle = (id) => {
        const { drawerLevel = 1 } = this.props;
        const { appState } = this.props.stores;
        const { drawerHeightMediumLarge } = appState;
        // Related entries only carry { id, title }; openArticle looks the uuidv4 up in
        // articleStore.articles and falls back to the drawer when it is not loaded.
        openArticle({
            stores: this.props.stores,
            id,
            drawerLevel,
            drawerProps: { height: drawerHeightMediumLarge },
        });
    }

    onRelatedChanged = (newList) => {
        const { articleStore } = this.props.stores;
        const { article } = articleStore;
        articleStore.updateKeyValue('article', { ...article, relatedArticles: newList });
    }

    openStatsDrawer = (event, articleId) => {
        event.stopPropagation();
        const { drawerLevel = 1 } = this.props;
        const { appState } = this.props.stores;
        const { drawerHeightLarge } = appState;
        appState.openDrawer('articleStats', {
            height: drawerHeightLarge,
            articleId,
        }, drawerLevel + 1);
    }

    componentDidMount() {
        this.loadAll();
        this.applyExternalLinkAttributes();
    }

    componentDidUpdate() {
        this.applyExternalLinkAttributes();
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.page !== this.props.page || nextProps.artid !== this.props.artid) {
            this.loadAll(nextProps);
        }
    }

    renderVideoFile = (file) => {
        const poster = file.s3LinkStreamPreview1;
        const { articleStore } = this.props.stores;
        const { article = {} } = articleStore;
        // Portrait clips open in the full-screen swipe player instead of playing
        // inline — a 9:16 video inside the feed column wastes most of the screen.
        // Members-only posts are excluded: get-shorts.js never lists them, so
        // routing there would deep-link into a player that can't find this clip
        // and silently pins to a different one. Fall through to the normal inline
        // player below instead.
        if (file.videoOrientation === 'portrait' && file.s3LinkStream && !article.requiresMembership) {
            return (
                <figure class='mb-0 px-3'>
                    <div
                        class='position-relative rounded-3 overflow-hidden mx-auto'
                        style={`max-width: 340px; aspect-ratio: 9/16; max-height: 70vh; cursor: pointer; background-image: url("${poster}"); background-size: cover; background-position: center;`}
                        onClick={() => route(`/feed/shorts/${article.uuidv4}`)}
                    >
                        <span
                            class='position-absolute top-50 start-50 translate-middle d-flex align-items-center justify-content-center rounded-circle'
                            style='width: 56px; height: 56px; background: rgba(0,0,0,0.45); border: 2px solid rgba(255,255,255,0.85);'
                        >
                            <i class='fa-solid fa-play text-white' style='font-size: 1.1rem; margin-left: 3px;' />
                        </span>
                    </div>
                    {(file.caption || file.photographer) && (
                        <figcaption class='text-body-secondary small mt-1 px-3'>
                            {file.caption}{file.caption && file.photographer && ' '}{file.photographer && <span class='fst-italic'>Foto: {file.photographer}</span>}
                        </figcaption>
                    )}
                </figure>
            );
        }
        if (file.s3LinkStream) {
            return (
                <figure class='mb-0'>
                    <div class='video-container rounded-lg'>
                        <VideoStreamingPlayer
                            key={file.s3LinkStream}
                            videoStreamUrl={file.s3LinkStream}
                            stores={this.props.stores}
                            poster={poster}
                            transcript={file.transcript}
                            transcriptionSegments={file.transcriptionSegments}
                            transcriptionLanguage={file.transcriptionLanguage}
                            transcriptEnglish={file.transcriptEnglish}
                            transcriptionSegmentsEnglish={file.transcriptionSegmentsEnglish}
                            transcriptSpanish={file.transcriptSpanish}
                            transcriptionSegmentsSpanish={file.transcriptionSegmentsSpanish}
                            transcriptFrench={file.transcriptFrench}
                            transcriptionSegmentsFrench={file.transcriptionSegmentsFrench}
                            transcriptFinnish={file.transcriptFinnish}
                            transcriptionSegmentsFinnish={file.transcriptionSegmentsFinnish}
                        />
                    </div>
                    {(file.caption || file.photographer) && (
                        <figcaption class='text-body-secondary small mt-1 px-3'>
                            {file.caption}{file.caption && file.photographer && ' '}{file.photographer && <span class='fst-italic'>Foto: {file.photographer}</span>}
                        </figcaption>
                    )}
                </figure>
            );
        }
        if (file.s3Link && file.s3Link.match(/\.(m4v|m4a|mp4)$/i)) {
            return (
                <figure class='mb-0'>
                    <div className='video-container rounded-lg'>
                        <video controls className='video-player'>
                            <source src={file.s3Link} type='video/mp4' />
                            Your browser does not support the video tag.
                        </video>
                    </div>
                    {(file.caption || file.photographer) && (
                        <figcaption class='text-body-secondary small mt-1 px-3'>
                            {file.caption}{file.caption && file.photographer && ' '}{file.photographer && <span class='fst-italic'>Foto: {file.photographer}</span>}
                        </figcaption>
                    )}
                </figure>
            );
        }
        if (file.s3Link && file.s3Link.match(/\.(mov)$/i)) {
            return (
                <figure class='mb-0'>
                    <div className='video-container rounded-lg'>
                        <video controls className='video-player'>
                            <source src={file.s3Link} type='video/quicktime' />
                            Your browser does not support the video tag.
                        </video>
                    </div>
                    {(file.caption || file.photographer) && (
                        <figcaption class='text-body-secondary small mt-1 px-3'>
                            {file.caption}{file.caption && file.photographer && ' '}{file.photographer && <span class='fst-italic'>Foto: {file.photographer}</span>}
                        </figcaption>
                    )}
                </figure>
            );
        }
        return null;
    }

    toggleMapInteraction = () => {
        this.setState({ mapInteractive: !this.state.mapInteractive });
    }

    renderArticleMap = (article) => {
        const markers = article.mapMarkers || [];
        if (!markers.length) return null;
        const zoom = article.mapZoom || 13;
        const center = article.mapCenter;
        const isInteractive = this.state.mapInteractive;
        let mapLat, mapLng;
        if (center?.latitude) {
            mapLat = center.latitude;
            mapLng = center.longitude;
        } else {
            mapLat = markers.reduce((sum, m) => sum + m.latitude, 0) / markers.length;
            mapLng = markers.reduce((sum, m) => sum + m.longitude, 0) / markers.length;
        }
        return (
            <div class='my-3 position-relative' style='height: 50vh; border-radius: 10px; overflow: hidden;'>
                <MapContainer
                    center={[mapLat, mapLng]}
                    zoom={zoom}
                    scrollWheelZoom={false}
                    dragging={false}
                    touchZoom={false}
                    doubleClickZoom={false}
                    boxZoom={false}
                    keyboard={false}
                    style={{ height: '100%', width: '100%' }}
                >
                    <MapInteractionToggle enabled={isInteractive} />
                    <TileLayer
                        attribution='&copy; <a href="https://statkart.no">Kartverket</a>'
                        url='https://cache.kartverket.no/v1/wmts/1.0.0/topograatone/default/webmercator/{z}/{y}/{x}.png'
                    />
                    {markers.map(m => {
                        const icon = L.divIcon({
                            html: `<div style="background: #dc3545; color: white; padding: 2px 8px; border-radius: 4px; font-size: 12px; white-space: nowrap; font-weight: bold; box-shadow: 0 1px 4px rgba(0,0,0,0.3);">${m.label || ''}</div>`,
                            className: 'map-marker-label',
                            iconSize: null,
                            iconAnchor: [12, 12],
                        });
                        return (
                            <Marker
                                key={m.uuidv4}
                                position={[m.latitude, m.longitude]}
                                icon={icon}
                            />
                        );
                    })}
                </MapContainer>
                <button
                    type='button'
                    class={`btn btn-sm ${isInteractive ? 'btn-primary' : 'btn-light'} rounded-pill shadow position-absolute`}
                    style='bottom: 10px; right: 10px; z-index: 1000;'
                    onClick={this.toggleMapInteraction}
                >
                    <i class={`fa-solid ${isInteractive ? 'fa-lock-open' : 'fa-lock'} me-1`} />
                    {isInteractive ? 'Lås kart' : 'Flytt kart'}
                </button>
            </div>
        );
    }

    componentWillUnmount() {
        const { appState } = this.props.stores;
        appState.restoreDefaultMetaTags();
    }

    render() {
        const {
            all,
            maxHeight = '80vh',
            imageStyles, // = 'aspect-ratio: 4 / 3',
            showLikes = true,
            showComments = true,
            showShareArticle = true
        } = this.props;
        const { appState, userStore, articleStore, presenceStore } = this.props.stores;
        const { mainView, subView, isDevelopment, path } = appState;
        const { user = {}, isAdmin, isMediaWorker, isTester, isVeterinary, language } = userStore;
        const darkmode= util.getNestedValue(user, 'settings.darkmode');

        const { article = {}, googleSheet } = articleStore;
        if (article.user > 0) {
            presenceStore.track(article.user);
        }
        const { activeTranslation, translationLoading } = this.state;
        // When a translation is active, swap title/ingress/body only — images,
        // videos, likes, comments and sharing keep the original article data.
        const translation = activeTranslation?.translation || {};
        const displayTitle = translation.title || article.title;
        const displayIngress = translation.ingress || article.ingress;
        const displayBody = translation.body || article.body;
        const hasVideo = article.files?.some(f => f.s3LinkStream || (f.s3Link && f.s3Link.match(/\.(m4v|m4a|mp4|mov)$/i)));
        // If all videos are placed inline via {{video.N}}, treat as no top-level video
        const allVideosInline = hasVideo && displayBody && (() => {
            const videoFiles = article.files.filter(f => f.s3LinkStream || (f.s3Link && f.s3Link.match(/\.(m4v|m4a|mp4|mov)$/i)));
            const inlineIndices = new Set();
            const inlineRegex = /\{\{video\.(\d+)\}\}/g;
            let m;
            while ((m = inlineRegex.exec(displayBody)) !== null) {
                inlineIndices.add(parseInt(m[1], 10));
            }
            return videoFiles.every((_, idx) => inlineIndices.has(idx));
        })();
        const showTopVideos = hasVideo && !allVideosInline;

        const linkTextClass = `${darkmode ? 'text-white' : 'text-dark'}`;
		const linkTextStyle = `line-height: 24px; font-size: 21px; font-weight: 400;`;

        return (<>
            <div class='w-100 d-flex justify-content-center position-relative' ref={c => { this.mainContainer = c; }}>
                <div class='w-100 h-100' style='max-width: 960px; padding-top: 0px; padding-bottom: 100px;'>
                   {/* {isAdmin && <div class={`position-absolute`} style={`top: 20px; right: 10px; z-index: 100000;`}>
                        <button onClick={this.editArticle} class={`btn btn-sm btn-outline-secondary rounded-pill me-2`}>
                            <i class={`fa-regular fa-pen me-2`} />
                            <Text id='article.edit'>Edit article</Text>
                        </button>
                    </div>} */}
                    <div class='w-100 d-flex flex-column'>
                        <div class='px-0 box-header-info d-flex flex-column'>
                            <div class='d-flex flex-column'>
                                {/* {JSON.stringify(part)} */}
                                {article.files?.length > 0 && (() => {
                                    // Build list of video files
                                    const videoFiles = article.files.filter(f =>
                                        f.s3LinkStream || (f.s3Link && f.s3Link.match(/\.(m4v|m4a|mp4|mov)$/i))
                                    );
                                    // Check which videos are placed inline via {{video.N}} tags
                                    const hasInlineVideos = displayBody && /\{\{video\.\d+\}\}/.test(displayBody);
                                    // If all videos are inline, don't render any at top
                                    if (hasInlineVideos) {
                                        // Only render videos NOT referenced inline
                                        const inlineIndices = new Set();
                                        const inlineRegex = /\{\{video\.(\d+)\}\}/g;
                                        let m;
                                        while ((m = inlineRegex.exec(displayBody)) !== null) {
                                            inlineIndices.add(parseInt(m[1], 10));
                                        }
                                        return videoFiles.map((file, vidIdx) => {
                                            if (inlineIndices.has(vidIdx)) return null;
                                            return this.renderVideoFile(file);
                                        });
                                    }
                                    return videoFiles.map(file => this.renderVideoFile(file));
                                })()}
                                {/* Sponsor bar: under the top videos (the streaming player owns the
                                    bottom edge for its controls), over the top images. */}
                                {showTopVideos && <ArticleSponsorOverlay inline articleId={article.id} surface='article' sponsors={article.sponsors} sponsorsMeta={article.sponsorsMeta} />}
                                {!showTopVideos && <div class='position-relative w-100'>
                                    <ImageScroller
                                        images={article.images || []}
                                        stores={this.props.stores}
                                        showImg={img => partImg(img, this.props, '1920x')}
                                        maxHeight={maxHeight}
                                        // imageContainerStyles={'aspect-ratio: 4 / 3'}
                                        imageStyles={imageStyles}
                                        rounded={false}
                                        fullscreenButtonStyle='top: 15px; right: 64px;'
                                        // maxWidth={maxWidth}
                                    />
                                    <ArticleSponsorOverlay articleId={article.id} surface='article' sponsors={article.sponsors} sponsorsMeta={article.sponsorsMeta} />
                                </div>}
                            </div>
                            <div class={`d-flex flex-column mx-3 mt-3 rounded-lg ${darkmode ? 'bg-darkmode' : 'bg-lightmode'} px-4 py-3`}>
                                <div>
                                    <span
                                        class='mb-0 mt-0 py-1 px-0'
                                        style={`font-size: clamp(0.8rem, 5vw, 1.2rem); font-weight: 700; line-height: 1.2em; text-transform: uppercase;`}
                                    >
                                        {article.headingIcon ? <i class={`${article.headingIcon} me-2`} /> : ''}
                                        {article.heading}
                                    </span>
                                </div>
                                <div>
                                    <h1 style={`font-size: clamp(1.5rem, 5vw, 4rem);`}>{displayTitle}</h1>
                                    {article.requiresMembership === true && (
                                        <span class='badge bg-warning text-dark'>
                                            <i class='fa-solid fa-lock me-1' /><Text id='paywall.badge'>Pluss</Text>
                                        </span>
                                    )}
                                </div>
                                <div class='font-weight-lighter d-flex flex-row align-items-center flex-wrap'>
                                    {article.user > 0 && article.creator && <span
                                        class='d-flex flex-row align-items-center me-3'
                                        style='cursor: pointer;'
                                        onClick={(event) => {
                                            event.stopPropagation();
                                            openUserProfileDrawer(appState, {
                                                userId: article.user,
                                                name: article.creator,
                                                image: article.creatorImage,
                                                faceBox: article.creatorImageFaceBox,
                                            });
                                        }}
                                    >
                                        <Avatar
                                            name={article.creator}
                                            image={article.creatorImage}
                                            faceBox={article.creatorImageFaceBox}
                                            size={28}
                                            online={presenceStore.onlineByUserId[article.user]}
                                        />
                                        <span class='ms-2'>{article.creator}</span>
                                    </span>}
                                    {util.formatDate(article.publishDate, { hour12: false, hour: '2-digit', minute: '2-digit', locale: 'nb-NO' })}
                                    <span class='ms-3'>
                                        <TranslationButtons
                                            collapsible={true}
                                            objectId={article.id}
                                            objectType='article'
                                            translations={article.translations}
                                            activeLanguage={activeTranslation?.language}
                                            onTranslate={this.handleTranslate}
                                            onClearTranslation={this.clearTranslation}
                                            loading={!!translationLoading}
                                            loadingLanguage={translationLoading}
                                        />
                                    </span>
                                </div>

                                {/* Stats section - visible to admins and article owners. Click opens detailed stats drawer. */}
                                {(isAdmin || article.user === user.id) && (article.totalViews > 0 || article.totalScrollViews > 0 || article.weeklyStats?.length > 0) && (
                                    <div
                                        class='d-flex flex-row align-items-center flex-wrap mt-2 mb-3 pb-2 border-bottom'
                                        style='cursor: pointer;'
                                        role='button'
                                        title='Show detailed statistics'
                                        onClick={(event) => this.openStatsDrawer(event, article.id)}
                                    >
                                        <span class='text-muted font-weight-light me-2'>
                                            <i class='fa-solid fa-chart-simple' /> Stats
                                        </span>
                                        <span class='badge text-bg-light me-2' title={`${article.totalViews || 0} page views + ${article.totalScrollViews || 0} scroll views`}>
                                            <i class='fa-solid fa-eye' /> {(article.totalViews || 0) + (article.totalScrollViews || 0)}
                                            {article.viewsTrend !== 0 && (
                                                <span class={`ms-1 ${article.viewsTrend > 0 ? 'text-success' : 'text-danger'}`}>
                                                    {article.viewsTrend > 0 ? '+' : ''}{article.viewsTrend}%
                                                </span>
                                            )}
                                        </span>
                                        {article.uniqueViews > 0 && (
                                            <span class='badge text-bg-light me-2' title='Unique viewers'>
                                                <i class='fa-solid fa-users' /> {article.uniqueViews}
                                            </span>
                                        )}
                                        {article.avgReadTime > 0 && (
                                            <span class='badge text-bg-light me-2' title='Average read time'>
                                                <i class='fa-solid fa-clock' /> {Math.round(article.avgReadTime / 1000)}s
                                            </span>
                                        )}
                                        {article.weeklyStats?.length > 1 && (
                                            <span class='badge text-bg-light me-2 py-1' title='Weekly trend'>
                                                <Sparkline
                                                    data={article.weeklyStats}
                                                    valueField='views'
                                                    height={18}
                                                    barWidth={4}
                                                    barGap={1}
                                                    maxBars={12}
                                                />
                                            </span>
                                        )}
                                        <span class='text-muted ms-auto'>
                                            <i class='fa-solid fa-chevron-right' />
                                        </span>
                                    </div>
                                )}

                                {article.tldr && (() => {
                                    const tldrLines = article.tldr.split('\n').filter(line => line.trim());
                                    const isExpanded = this.state.tldrExpanded;
                                    const totalChars = article.tldr.length;
                                    const needsCollapse = tldrLines.length > 2 || totalChars > 200;
                                    return (
                                        <div class='rounded-4 bg-body-secondary p-4 mb-3 position-relative'>
                                            <h5 class='fw-bold mb-3'>Kortversjonen</h5>
                                            <div class='position-relative' style={!isExpanded && needsCollapse ? 'max-height: 4.5em; overflow: hidden;' : ''}>
                                                <ul class='list-unstyled mb-0' style='padding-left: 0;'>
                                                    {tldrLines.map((line, idx) => (
                                                        <li key={idx} class='d-flex align-items-start mb-2'>
                                                            <span class='me-2 mt-1 flex-shrink-0' style='width: 10px; height: 10px; background: var(--bs-danger, #dc3545); border-radius: 50%; display: inline-block;' />
                                                            <span>{line.replace(/^[-•]\s*/, '')}</span>
                                                        </li>
                                                    ))}
                                                </ul>
                                                {!isExpanded && needsCollapse && (
                                                    <div class='position-absolute bottom-0 start-0 end-0' style='height: 4em; background: linear-gradient(transparent, var(--bs-secondary-bg));' />
                                                )}
                                            </div>
                                            {needsCollapse && (
                                                <button
                                                    type='button'
                                                    class='btn btn-dark btn-sm rounded-pill mt-2 px-3'
                                                    onClick={() => this.setState({ tldrExpanded: !isExpanded })}
                                                >
                                                    {isExpanded ? 'Vis mindre' : 'Vis mer'}
                                                </button>
                                            )}
                                        </div>
                                    );
                                })()}

                                <div class='d-flex flex-column mb-3 font-weight-bold'>
                                    <MarkdownDisplay markdown={fixImageSrc(localUtil.replaceImages(linkifyMentions(displayIngress, article.mentions), article.images, language, false))} markedOpts={localUtil.getMarkdownOptions()} stores={this.props.stores} articleId={article.id} />
                                </div>
                                {Array.isArray(article.fishCatches) && article.fishCatches.length > 0 && (
                                    <div class='d-flex flex-column gap-2 mt-3'>
                                        {article.fishCatches.map(fishCatch => (
                                            <FishCatchCard key={fishCatch.uuidv4} fishCatch={fishCatch} />
                                        ))}
                                    </div>
                                )}
                                {Array.isArray(article.fishContacts) && article.fishContacts.length > 0 && (
                                    <div class='d-flex flex-column gap-2 mt-3'>
                                        {article.fishContacts.map(fishContact => (
                                            <FishContactCard key={fishContact.uuidv4} fishContact={fishContact} />
                                        ))}
                                    </div>
                                )}
                                <div class='d-flex flex-column'>
                                    {renderArticleBody({
                                        article,
                                        body: displayBody,
                                        language,
                                        stores: this.props.stores,
                                        renderVideoFile: this.renderVideoFile,
                                        renderArticleMap: this.renderArticleMap,
                                    })}
                                </div>

                                {article.paywalled === true && <PaywallCta />}

                                {/* Map embed - shown after body if no {{map}} marker and markers exist */}
                                {article.mapMarkers?.length > 0 && !displayBody?.includes('{{map}}') && (
                                    this.renderArticleMap(article)
                                )}

                                {/* Results lists - shown after body if no {{results.N}} markers */}
                                {article.resultsLists?.length > 0 && !displayBody?.match(/\{\{results\.\d+\}\}/) && (
                                    article.resultsLists.map((rl, idx) => (
                                        <ResultsList key={`results-fallback-${idx}`} resultsList={rl} stores={this.props.stores} />
                                    ))
                                )}

                                {article.googleSheetId && <>
                                    {googleSheet && googleSheet?.title ? <>
                                        <div class='d-flex flex-column my-3'>
                                            <GoogleSheet
                                                doc={googleSheet}
                                                stores={this.props.stores}
                                            />
                                        </div>
                                    </> : <>
                                        <div class='d-flex flex-column justify-content-center align-items-center my-3'>
                                            <span class='text-muted'>
                                                <Text id='article.googlesheet-loading'>Google sheet loading...</Text>
                                            </span>
                                            <div class='spinner-border text-primary' role='status'>
                                                <span class='sr-only'>Loading...</span>
                                            </div>
                                        </div>
                                        <PlaceholderTable rows={10} columns={5} />
                                        {/* <Placeholder count={5} style={{ width: '100%', height: '20px' }} /> */}
                                    </>}
                                    {/* <xmp>{JSON.stringify(googleSheet, null, 2)}</xmp> */}

                                </>}
                            </div>

                            {(showLikes || showComments) && <div class={`d-flex flex-column mx-3 mt-3 rounded-lg ${darkmode ? 'bg-darkmode' : 'bg-lightmode'} px-4 py-3`}>
                                {showLikes && <Likes
                                    stores={this.props.stores}
                                    type={'article'}
                                    objectId={article.id}
                                    likes={article.likes}
                                    showShare={true}
                                    uuidv4={article.uuidv4}
                                    shareTitle={article.title}
                                    shareSummary={article.ingress || article.body}
                                    shareImage={article.images?.[0]?.s3SmallLink}
                                />}
                                {showComments && <Comments stores={this.props.stores} type={'article'} objectId={article.id} comments={article.comments} />}
                            </div>}

                            {article.files && article.files.length > 0 && <>
                                <div class={`d-flex flex-column mx-3 mt-4 rounded-lg ${darkmode ? 'bg-darkmode' : 'bg-lightmode'} px-4 py-3`}>
                                    <div class='d-flex flex-column'>
                                        {article.files.map(file => {
                                            return (<>
                                                <a href={file.s3Link} class='badge text-bg-light border me-2' target='_blank' rel='noopener noreferrer'>{file.name} <span class='font-weight-lighter'>({localUtil.formatFileSize(file.size)})</span></a>
                                            </>);
                                        })}
                                    </div>
                                </div>
                            </>}

                            {(article.tags?.length > 0) && <div class={`d-flex flex-column mx-3 mt-4 rounded-lg ${darkmode ? 'bg-darkmode' : 'bg-lightmode'} px-4 py-3`}>
                                {this.viewTags(article)}
                            </div>}

                            {/* Curated/AI related articles (embedded in the article payload — no extra fetch) */}
                            {(article.relatedArticles?.length > 0 || ((isAdmin || isMediaWorker) && article.category === 'help')) && (
                                <div class={`d-flex flex-column mx-3 rounded-lg ${darkmode ? 'bg-darkmode' : 'bg-lightmode'} px-4 pb-3`}>
                                    <RelatedArticles
                                        stores={this.props.stores}
                                        article={article}
                                        canEdit={(isAdmin || isMediaWorker) && article.category === 'help'}
                                        onOpenArticle={this.openRelatedArticle}
                                        onChanged={this.onRelatedChanged}
                                    />
                                </div>
                            )}

                            {/* Related Posts */}
                            {article.id && (
                                <div class={`d-flex flex-column mx-3 mt-4 rounded-lg ${darkmode ? 'bg-darkmode' : 'bg-lightmode'}`}>
                                    <RelatedPosts
                                        stores={this.props.stores}
                                        articleId={article.id}
                                        darkmode={darkmode}
                                    />
                                </div>
                            )}

                            {showShareArticle && <div class={`d-flex flex-row justify-content-center mx-3 mt-4 rounded-lg px-4 py-3`}>
                                {/* <small>
                                    <ClipboardCopy
                                        label={<><i class='fa-duotone fa-link' /> <Text id='article.link'>Link to article</Text></>}
                                        text={`${window.location.protocol}//${window.location?.hostname}${window.location.port ? `:${window.location.port}` : ''}/#/article/${encodeURIComponent(article.title).toLocaleLowerCase()}/${article.uuidv4}`}
                                    />
                                </small> */}
                                <small class=''>
                                    <ClipboardCopy
                                        label={<><i class='fa-duotone fa-share' /> <Text id='article.share'>Share article</Text></>}
                                        text={`${window.location.protocol}//${window.location?.hostname}${window.location.port ? `:${window.location.port}` : ''}/share/article/${article.uuidv4}?domain=${window.location?.hostname}${window.location.port ? `:${window.location.port}` : ''}`}
                                    />

                                    {/* <a href={`/article/${encodeURIComponent(article.title).toLocaleLowerCase()}/${article.uuidv4}`} onClick={this.closeAllDrawers}>
                                        <i class='fa-duotone fa-link' /> <Text id='article.link'>Link to article</Text>
                                    </a> */}
                                </small>
                            </div>}
                        </div>
                    </div>

                    {/* <SimpleBlog stores={this.props.stores} {...this.props} /> */}
                </div>
            </div>
        </>);
    }
}

export default ArticleView;
